// extracted by mini-css-extract-plugin
module.exports = {"multi-step__heading":"MultiStep_multi-step__heading__1jgvi"};